var _defs, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDryer(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 160 160",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#1d1d1b;stroke-linejoin:round;stroke-width:1.7px}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "m119.19 80.68 4.7-.62v-32.9l-4.7-.62v34.14zm4.7-33.52-67.77-9.39m67.77 42.29-67.77 9.39m0-51.68a25.83 25.83 0 0 0-6.6 50.81 25.26 25.26 0 0 0 6.6.87m67.77-42.29v32.9M39.68 49.51h-5.02m5.02 28.2h-5.02m5.02-18.8h-8.89m8.89 9.4h-8.89m88.4-18.8v28.2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M43.51 86.36c.45.19 14.61 21.65 12.26 54.55m9.68-52.63s.77 4.93 1.6 8.22a63.2 63.2 0 0 1 1.45 9.4 121.87 121.87 0 0 1-.63 23.49"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M67.87 129.39c-1.22 6.65-9 13.86-12.1 11.52M67.05 96.5h5.52m0 0v9.4m0 0H68.5M55.41 42.85v41.52m76.8-20.76h16.27m-16.27-11.75h12.99m-12.99 23.5h12.99"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M145.25 41.5V19.49H14.46v120.73h28.66m32.04 0h70.09V86.48",
    style: {
      strokeMiterlimit: 10,
      strokeWidth: "1.98px",
      fill: "none",
      stroke: "#1d1d1b"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDryer);
export default __webpack_public_path__ + "static/media/dryer.870af747.svg";
export { ForwardRef as ReactComponent };